import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { CheckboxEnum, Button, DatePicker } from '../basic';

export default class PlatformManagement extends Component {
  constructor(props) {
    super(props);
    this.viewModel = cb.loader.initMetaCommonViewModel('PlatformManagementViewModel', 'platformManagementViewModel');
  }
  render() {
    return (
      <Row className="Platform_management">
        <Row>
          <div className='viewCell' style={{ width: 'auto' }}>
            <Row style={{ height: 32 }}><div className='label-control'>自定义项</div></Row>
          </div>
          <Button model={this.viewModel.get('upgradeUserDef')} value='更新' />
        </Row>
        <Row>
          <div className='viewCell' style={{ width: 'auto' }}>
            <CheckboxEnum model={this.viewModel.get('cacheType')} cShowCaption='缓存类型' />
          </div>
          <Button className="Platform_management_btn" model={this.viewModel.get('refreshCache')} value='刷新' />
        </Row>
		<Row>
          <div className='viewCell' style={{ width: 'auto' }}>
            <Row style={{ height: 32 }}><div className='label-control'>审批流</div></Row>
          </div>
          <Button model={this.viewModel.get('bpmInit')} value='初始化' />
        </Row>
        <Row>
          <Button model={this.viewModel.get('enumUpgrade')} value='枚举升级'/>
        </Row>
        <Row colCount={12}>
          <Col span={4} >
            <DatePicker model={this.viewModel.get('uninstallDate')} />
          </Col>
          <Col span={8}><Button model={this.viewModel.get('uninstall')} value='数据卸载' /></Col>
        </Row>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/platform-management/index.jsx